import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en_translation from "./locales/en/translation.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    resources: {
      en: {
        translation: en_translation
      }
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
